import { useQuery } from "react-query";
import { zoneDatasource } from "../datasource/ZoneDatasource";

const fetchZones = async () => {
  const company = JSON.parse(localStorage.getItem("company")!);
  const res = await zoneDatasource.getAllZoneByCompany(company?.companyCode);
  return res.map((item: any) => ({
    label: item.zoneName,
    value: item.zoneName,
    key: item.zoneId,
  }));
};

export const useZones = () => {
  return useQuery({
    queryKey: ["zones"],
    queryFn: fetchZones,
    staleTime: 1000 * 60 * 5,
  });
};
